export const Data=[

    {
        id:1,
        year:2018,
        userGain:-45677,
        userLost:345,
    },
    {
        id:2,
        year:2019,
        userGain:456770,
        userLost:344,
    },
    {
        id:3,
        year:2020,
        userGain:456970,
        userLost:345,
    },
    {
        id:4,
        year:2021,
        userGain:457000,
        userLost:345,
    },
]